<template>
  <QATranslationProbe :definition="translations.e2eTranslationCheck" />
</template>

<script setup lang="ts">
import QATranslationProbe from '@backmarket/nuxt-module-i18n/QATranslationProbe.vue'

import translations from './ProductPageQATranslationsProbe.translations'
</script>
